package com.milta.core.localization.translations.en

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "My subscription",
    screenSubtitle = "Manage your Milta subscription",
    planDriver = "Driver",
    planOrganisation = "Enterprise",
    statusActive = "Active",
    statusTrial = "Free trial",
    statusExpired = "Expired",
    statusCancelled = "Cancelled",
    platformLabel = "Platform",
    productIdLabel = "Product",
    expiresAtLabel = "Expires on",
    noExpiry = "No expiry date",
    noValue = "—",
    noSubscription = "No active subscription",
    activateButton = "Activate subscription",
    successActivated = "Subscription activated successfully",
    perMonth = "/month",
    pitchTitle = "Unlock all Milta features",
    pitchSubtitle = "Choose the plan that fits your activity to keep delivering and managing your routes.",
    featuredBadge = "ALL INCLUDED",
    driverFeature1 = "Unlimited routes & deliveries",
    driverFeature2 = "Photo proof of delivery + signature",
    driverFeature3 = "Real-time notifications",
    orgFeature1 = "Unlimited team management",
    orgFeature2 = "Full web dashboard",
    orgFeature3 = "Route import (Excel, PDF, photo)",
    orgFeature4 = "Driver access included for yourself",
    purchaseFinePrint = "Secure payment via the store. Cancel anytime from the store's settings.",
    purchasingLabel = "Processing…",
    activeCaption = "Your Milta subscription",
    nextRenewalLabel = "Next renewal",
    includedTitle = "Included in your plan",
    manageOnGooglePlay = "Manage on Google Play",
    manageOnAppStore = "Manage on App Store",
    viewTechnicalDetails = "View technical details",
    monthNames = listOf("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"),
    errorNotFound = "No active subscription found",
    errorConflict = "An active subscription already exists for this account",
    errorPlanMismatch = "The selected plan does not match your account role",
    errorPlanRequired = "Please select a plan",
    errorPlanInvalid = "Invalid plan selected",
    errorPlatformRequired = "Platform is required",
    errorPlatformInvalid = "Invalid platform. Must be AppStore or GooglePlay",
    errorStoreProductIdRequired = "Store product ID is required",
    errorReceiptTokenRequired = "Receipt token is required",
    errorGeneric = "An error occurred. Please try again.",
    trialBannerDaysPrefix = "🎉 Free trial: you have ",
    trialBannerDaysBold = "%d days",
    trialBannerDaysSuffix = " left to discover Milta with no commitment.",
    trialBannerHoursPrefix = "⏰ Your free trial ends in ",
    trialBannerHoursBold = "%dh",
    trialBannerHoursSuffix = ": subscribe to keep using Milta without interruption.",
)
